const PRINT_BODY_CLASS = "reports-printing"

// Toggle a body flag so the print stylesheet can isolate the report canvas,
// then restore it once the browser's print dialog closes.
export const printReportCanvas = (): void => {
  if (typeof document === "undefined") return
  document.body.classList.add(PRINT_BODY_CLASS)

  const cleanup = () => {
    document.body.classList.remove(PRINT_BODY_CLASS)
    window.removeEventListener("afterprint", cleanup)
  }
  window.addEventListener("afterprint", cleanup)

  window.print()
}
